import React, { useCallback, useState, useEffect, useContext } from 'react';

import PbxContext from '../../context/PbxContext';
import '../../libs/bulma.min.css';

import { exportSelectAllQueues, accessLocalStorage } from '../../services';
import QueueList from '../../components/Events/QueueList';


import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen } from '@fortawesome/free-solid-svg-icons';
import QueueAgents from '../../components/Queues/QueueAgents';

function QueueEvents() {
  const getItensStateGlobal = useContext(PbxContext);
  const { toggleIsHidden, toggleIsChangeFormElements } = getItensStateGlobal;
  
  const [ queues, setQueues] = useState([]);
  const [ queuesSelected, setQueuesSelected] = useState([]);
  const [ queuesSelectedAwaiting, setQueuesSelectedAwaiting] = useState([]);
  const [disable, setDisable] = useState(true);

  const fetchQueuesLocalStorage = async () => {
    const storageQueues = await accessLocalStorage.getItemInKey('queues');
    if(storageQueues === null) return false;
    return storageQueues;
  };

  const getInitialQueues = async () => {
    try {
      const receivedQueues = await exportSelectAllQueues();
      const transformQueues = receivedQueues.map((queue) => queue.queuesselect)
      const dataUser = await accessLocalStorage.getUserLocalStorage();

      let { user: { queuesviewer }} = dataUser;
      const visibility = queuesviewer !== 'all' ? queuesviewer.split(',') : [];
      visibility.length > 0 ? setQueues(transformQueues.filter((queue) => {
        if(visibility.includes(queue)) return queue;
      })) : setQueues(transformQueues);

      const queueStorageExist = await fetchQueuesLocalStorage();

      if(queueStorageExist.length >= 1) {
        setQueues(queueStorageExist);
        setQueuesSelected(queueStorageExist);
        toggleIsChangeFormElements('select-queues', 'columns is-hidden');
        toggleIsChangeFormElements('list-queues', 'columns is-multiline is-centered is-active');
        return queueStorageExist;
      }

    } catch (error) {
      return error;
    }
  };

  const deleteQueueScreem = async (data) => {
    const filterQueues = queues.filter((queue) => queue !== data);
    setQueuesSelected(filterQueues);
    setQueues(filterQueues);
    accessLocalStorage.setItemInKey('queues', filterQueues);

    if (filterQueues.length === 0) return window.location.reload(true);
    // return window.location.reload(true);
    return getInitialQueues();
  };

  const handleClickUpdate = () => {
    if(queuesSelectedAwaiting.length < 1) return;
    accessLocalStorage.setItemInKey('queues', queuesSelectedAwaiting);
    toggleIsChangeFormElements('select-queues', 'columns is-multiline is-hidden');
    toggleIsChangeFormElements('list-queues', 'columns is-multiline is-centered mx-1 mt-1');
    
    setQueuesSelected(queuesSelectedAwaiting);
    console.log(queuesSelectedAwaiting);
    return getInitialQueues();
  };

  const handleChangeSelectedQueues = (element) => {
    // setQueuesSelected((prevState) => {
    //   const onlineState = prevState.includes(element) ? [...prevState.filter((e) => e !== element)] : [...prevState, element];
    //   onlineState.length > 0 ? setDisable(false) : setDisable(true);
    //   return onlineState;
    // });
    setQueuesSelectedAwaiting((prevState) => {
      const onlineState = prevState.includes(element) ? [...prevState.filter((e) => e !== element)] : [...prevState, element];
      onlineState.length > 0 ? setDisable(false) : setDisable(true);
      return onlineState;
    });
  };

  useEffect(() => {
   let cancel = false;
    
   if (cancel) return;
   getInitialQueues();

   return () => {
     cancel = true
   };
  }, []);

  return (
    <div className="card section">
      <div className="columns">
        <div className="column is-half is-offset-one-quarter has-text-centered">
          <strong className="is-size-3">Filas</strong>
        </div>
      </div>
      <div name="select-queues" className="columns">
        <article className="panel is-info is-4 is-offset-4 column has-text-centered">
          <p className="panel-heading">
            Filas Disponíveis
          </p>
          {
            queues.map((queue) => {
              return (
                <a className="panel-block" key={ queue }>
                  <input type="checkbox" value={ queue } onChange={ (e) => handleChangeSelectedQueues(e.target.value)} />
                  <span className="ml-5">{ queue }</span>
                </a>
              )
            })
          }
          <div id="buttons" className="column is-half is-offset-one-quarter has-text-centered is-active">
              <button className="button is-info is-half mx-3 mt-2 px-6" type="submit" onClick={ () => handleClickUpdate() } disabled={ disable }>
                    <span className="icon">
                      <FontAwesomeIcon icon={ faPen } fixedWidth />
                    </span>
                    <span>
                      FILTRAR
                    </span>
              </button>
          </div>
        </article>
      </div>
      <div name="list-queues" className="is-hidden">
          { queuesSelected.map((queue) => <QueueList key={ queue } queueName={ queue } queueRemove={ deleteQueueScreem }/>) }
      </div>
    </div>
  );
}

export default QueueEvents;
